import { useEffect, useState } from "react";

import { EMPTY_SEARCH_PARAMS, ITEMS_PER_PAGE } from "../utils";
import { useDrugsFileSearch } from "./useDrugsFileSearch";

export const useDrugsFilePage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(ITEMS_PER_PAGE);
  const [searchParams, setSearchParams] = useState(EMPTY_SEARCH_PARAMS);
  const [debouncedSearchParams, setDebouncedSearchParams] = useState(EMPTY_SEARCH_PARAMS);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setCurrentPage(1);
      setDebouncedSearchParams(searchParams);
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchParams]);

  const { data, isFetching } = useDrugsFileSearch({
    page: currentPage,
    rows: rowsPerPage,
    searchParams: debouncedSearchParams,
  });

  const drugs = data?.data ?? (Array.isArray(data) ? data : []);
  const totalRecords = data?.totalRecords ?? (Array.isArray(data) ? data.length : 0);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsChange = (rows) => {
    setRowsPerPage(rows);
    setCurrentPage(1);
  };

  const handleSearchChange = (field, value) => {
    setSearchParams((previous) => ({
      ...previous,
      [field]: value,
    }));
  };

  const clearSearch = () => {
    setSearchParams(EMPTY_SEARCH_PARAMS);
  };

  return {
    drugs,
    isLoading: isFetching,
    totalRecords,
    currentPage,
    rowsPerPage,
    searchParams,
    handlePageChange,
    handleRowsChange,
    handleSearchChange,
    clearSearch,
  };
};
